import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const partnersCarousels = document.querySelectorAll(
    '.partners-carousel-block-01 .partners-carousel__carousel'
  );

  if (0 < partnersCarousels.length) {
    partnersCarousels.forEach((carousel) => {
      const playBtn = carousel.querySelector('.playBtn');
      const pauseBtn = carousel.querySelector('.pauseBtn');
      const items = carousel.querySelectorAll('.swiper-slide');
      const args = {
        slidesPerView: 2,
        spaceBetween: 20,
        autoplay: {
          delay: 2000,
        },

        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1080: {
            slidesPerView: 5,
            spaceBetween: 100,
          },
        },

        a11y: {
          firstSlideMessage: _x(
            'This is the first element',
            'swiper label',
            'vtx'
          ),
          lastSlideMessage: _x(
            'This is the last element',
            'swiper label',
            'vtx'
          ),
          prevSlideMessage: _x('Previous element', 'swiper label', 'vtx'),
          nextSlideMessage: _x('Next element', 'swiper label', 'vtx'),
          slideLabelMessage: _x(
            'Element {{index}} of {{slidesLength}}',
            'swiper label',
            'vtx'
          ),
          paginationBulletMessage: _x(
            'Go to element {{index}}',
            'swiper label',
            'vtx'
          ),
        },
      };

      if (5 < items.length) {
        args.loop = true;
        args.centeredSlides = true;
      } else {
        args.loop = false;
        args.watchOverflow = true;
        args.centerInsufficientSlides = true;
      }

      const partnerSwiper = new Swiper(carousel, args);

      if (playBtn && pauseBtn) {
        if (partnerSwiper.isLocked) {
          pauseBtn.classList.remove('visible');
          playBtn.classList.remove('visible');
        } else {
          pauseBtn.classList.add('visible');
          playBtn.classList.remove('visible');
          partnerSwiper.autoplay.start();
        }

        pauseBtn.addEventListener('click', () => {
          partnerSwiper.autoplay.pause();
          playBtn.classList.add('visible');
          pauseBtn.classList.remove('visible');
        });
        playBtn.addEventListener('click', () => {
          partnerSwiper.autoplay.start();
          playBtn.classList.remove('visible');
          pauseBtn.classList.add('visible');
        });

        partnerSwiper.on('lock', () => {
          pauseBtn.classList.remove('visible');
          playBtn.classList.remove('visible');
        });

        partnerSwiper.on('unlock', () => {
          pauseBtn.classList.add('visible');
          playBtn.classList.remove('visible');
          partnerSwiper.autoplay.start();
        });
      }
    });
  }
});
